import { Modal } from "antd";

const WorkshopDetails = ({ isModal, setIsModal, data,modalname="Workshop" }) => {
  return (
    <Modal
      className=""
      visible={isModal}
      onCancel={() => {
        setIsModal(false);
      }}
      centered={true}
      footer={null}
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body px-4 pb-5">
            <div>
              <h4 class="mb-1 ct_fs_20">{modalname} Booking Details</h4>
              <p class="mb-0 ct_grey_text">
                See full details for this newly registered user
              </p>
            </div>

            <ul className="ct_webinar_grid_2 mt-4">
              <li style={{ gridTemplateColumns: "120px auto" }}>
                <p className="mb-0 ct_fs_14">Title </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.title ?? ""}
                </p>
              </li>
              <li style={{ gridTemplateColumns: "120px auto" }}>
                <p className="mb-0 ct_fs_14">Name </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">{data?.name ?? ""}</p>
              </li>
              <li style={{ gridTemplateColumns: "120px auto" }}>
                <p className="mb-0 ct_fs_14">Email </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.email ?? ""}
                </p>
              </li>
              {/* <li>
                <p className="mb-0 ct_fs_14">Timezone </p>
                <p className="mb-0 ct_fs_14 ct_grey_text">
                  {data?.timezone ?? ""}
                </p>
              </li> */}
              {data?.notes && (
                <li style={{ gridTemplateColumns: "120px auto" }}>
                  <p className="mb-0 ct_fs_14">Notes </p>
                  <p className="mb-0 ct_fs_14 ct_grey_text">
                    {data?.notes ?? ""}
                  </p>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WorkshopDetails;
